    import React, { useState, useEffect } from "react";
    import AddProductsUi from "../../../ui/productsUi/addProductsUi";
    import { GetCategoriesData, GetStoresData } from "../../../lib/data";
    import i18n from "../../../lib/i18n";

    export default function AddProducts() {

    const [categoriesData, setCategoriesData] = useState([]);
    const [storesData, setStoresData] = useState([]);
    const t = i18n.t.bind(i18n);

    useEffect(() => {
        handleApi();
    }, []);

    const handleApi = async () => {
        const params = [{"status": "sub"}];
        try {
            const categories = await GetCategoriesData(1, params);
            const stores = await GetStoresData();
            setCategoriesData([]);
            setStoresData([]);
            categories.data?.map((e) => setCategoriesData((prev) => [...prev, e]));
            stores.data?.map((e) => setStoresData((prev) => [...prev, e]));
            } catch (err) {
            setCategoriesData([]);
            setStoresData([]);
        };
    };

    const searchCategories = async (param) => {
        const params = [{ "name": param }, {"status": "sub"}];
        if (param) {
            const res = await GetCategoriesData(1, params);
            setCategoriesData([]);
            res.data?.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };


    const searchStores = async (param) => {
        const params = [{ name: param }];
        if (param) {
            const res = await GetStoresData(1, params);
            setStoresData([]);
            res.data?.map((e) => setStoresData((prev) => [...prev, e]));
        }
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.products")}</h1>
                <AddProductsUi
                    categoriesData={categoriesData}
                    storesData={storesData}
                    searchCategories={searchCategories}
                    searchStores={searchStores}
                />
            </div>
        </div>
    );
    }